module.exports = __webpack_public_path__ + "img/2025big19.8cdd48c8.jpg";